import { ExpressionType } from '../../IExpression';
import { createExpressionType } from '../../IExpressionType';
import { ISwitchExpression } from './ISwitchExpression';
import { SwitchExpressionSchema } from './SwitchExpressionSchema';

export const SwitchExpressionType = createExpressionType<ISwitchExpression>({
  type: ExpressionType.Switch,
  schema: SwitchExpressionSchema,
  evaluate(expression, scope) {
    // Per ogni caso dello switch, valuta la condizione e se è vera restituisci il valore
    for (const expressionCase of expression.cases) {
      const condition = scope.evaluate(expressionCase.condition) as boolean;
      if (condition) {
        return scope.evaluate(expressionCase.value);
      }
    }

    // Se nessuna condizione è vera, restituisci il valore di default
    return scope.evaluate(expression.defaultValue);
  },
  getReferences(expression, collect) {
    const conditionReferences = expression.cases
      .flatMap(c => c.condition)
      .flatMap(collect);
    const valuesReferences = expression.cases
      .flatMap(c => c.value)
      .flatMap(collect);

    return [
      ...conditionReferences,
      ...valuesReferences,
      ...collect(expression.defaultValue),
    ];
  },
  toString(expression, toString) {
    return (
      '( ' +
      expression.cases
        .flatMap(c => c.condition)
        .map(toString)
        .join(` | `) +
      ' )'
    );
  },
});
